
@if (isReady) {
  <mat-toolbar class="filters">
    <mat-toolbar-row>
      @if (isDisplayed('startDate')) {
        <mat-form-field>
          <!--suppress HtmlFormInputWithoutLabel -->
          <input name="startDate"
            [formControl]="controls.startDate"
            matInput
            [matDatepicker]="startPicker"
            placeholder="{{'generic.beginning_date' | translate}}"
            />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        }
        @if (isDisplayed('endDate')) {
          <mat-form-field>
            <!--suppress HtmlFormInputWithoutLabel -->
            <input name="endDate"
              [formControl]="controls.endDate"
              matInput
              [matDatepicker]="endPicker"
              placeholder="{{'generic.deadline' | translate}}"
              />
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
          }
          @if (isDisplayed('view')) {
            <mat-form-field>
              <mat-select [formControl]="controls.view" placeholder="{{ 'graph.views' | translate }}" data-e2e="graph-view">
                <mat-option value="simple">{{ 'graph.views_simple' | translate }}</mat-option>
                <mat-option value="complex">{{ 'graph.views_complex' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if (isDisplayed('attendanceView')) {
            <mat-form-field>
              <mat-select [formControl]="controls.attendanceView" placeholder="{{ 'graph.views' | translate }}" data-e2e="graph-attendance">
                <mat-option value="global">{{ 'graph.attendance_views_global' | translate }}</mat-option>
                <mat-option value="activity">{{ 'graph.attendance_views_activity' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          }
          @if (isDisplayed('exerciseType')) {
            <mat-form-field>
              <mat-select [formControl]="controls.exerciseType" placeholder="{{ 'graph.progression_exercise_type' | translate }}" data-e2e="graph-exercicetype">
                @if (isEmptyAllowed('exerciseType')) {
                  <mat-option [value]="">{{ 'graph.progression_none' | translate }}</mat-option>
                }
                @for (exerciseType of exerciseTypes; track exerciseType) {
                  <mat-option [value]="exerciseType.get('name')">{{ exerciseType.get('name') }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (isDisplayed('multiLesson')) {
            <mat-form-field>
              <mat-select [formControl]="controls.multiLesson" placeholder="{{ 'graph.progression_select_lessons' | translate }}" data-e2e="graph-multilesson" multiple>
                @for (lesson of lessons; track lesson) {
                  <mat-option [value]="lesson.get('metadatas')?.title">{{lesson.get('metadatas')?.title}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (isDisplayed('errors')) {
            <mat-form-field>
              <mat-select [formControl]="controls.errors" placeholder="{{ 'graph.progression_select_errors' | translate }}" data-e2e="graph-error" multiple>
                @for (error of errors; track error) {
                  <mat-option [value]="error">{{error}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </mat-toolbar-row>
        <mat-toolbar-row>
          @if (isDisplayed('group')) {
            <mat-form-field>
              <mat-select [formControl]="controls.group"  placeholder="{{ 'graph.select_groups' | translate }}" data-e2e="graph-group2">
                <mat-option></mat-option>
                @for (group of groups; track group) {
                  <mat-option [value]="group.groupname">{{ group.groupname }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (isDisplayed('workgroup')) {
            <mat-form-field>
              <mat-select [formControl]="controls.workgroup" placeholder="{{ 'graph.select_workgroups' | translate }}" data-e2e="graph-workgroup" >
                <mat-option></mat-option>
                @for (workgroup of workgroups; track workgroup) {
                  <mat-option
                  [value]="workgroup.workgroupname">{{ workgroup.workgroupname }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (isDisplayed('learner')) {
            <mat-form-field>
              <label>
                <input type="text"
                  [placeholder]="'graph.learner' | translate"
                  matInput
                  [formControl]="controls.learner"
                  [matAutocomplete]="autoLearner">
                </label>
                <mat-autocomplete #autoLearner="matAutocomplete">
                  @for (learnerNickname of filteredLearners | async; track learnerNickname) {
                    <mat-option appAriaTitle [value]="learnerNickname">
                      {{learnerNickname}}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            }
            @if (isDisplayed('multiLearner')) {
              <mat-form-field>
                <mat-select [formControl]="controls.multiLearner" placeholder="{{ 'graph.select_learners' | translate }}" data-e2e="graph-multilearner" multiple>
                  @for (learnerNickname of filteredByGroupLearners | async; track learnerNickname) {
                    <mat-option [value]="learnerNickname">{{learnerNickname}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (couldExpend()) {
              <button (click)="toggle()" class="btn-collapse">
                <span>{{ (barIsExpended ? 'filters.button.collapse' : 'filters.button.expand') | translate }}</span>
                <mat-icon class="collapsable-arrow" [svgIcon]="barIsExpended ? 'keyboard_arrow_down' : 'keyboard_arrow_up'"></mat-icon>
              </button>
            }
          </mat-toolbar-row>
        </mat-toolbar>
      } @else {
        <mat-spinner></mat-spinner>
      }
